import { Service } from './service.model';
import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';

@Injectable({providedIn: 'root'})

export class ServicesService extends BaseService<Service> {

    constructor(
        protected injector:Injector,
    ){
        super(injector);
        this.copyJsonDataToObjectFunction=Service.fromJsonToObject
        this.urls={getAllUrl:'services',saveUrl:'regServico',updateUrl:'up-servico',deleteUrl:'dst-servico'}
    }

}